
<template>
  <div class="container_profile">
    <b-container>
      <b-row class="header_profile">
        <b-col>
          <div @click="backToProperHome()" style="cursor:pointer;margin-top:20px;">
            <font-awesome-icon style="font-size:28px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="content_form">
        <b-col cols="12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight:500;">
          Meu Perfil
        </b-col>
        <b-col cols="12" style="height:50px;line-height:50px;margin-top:10px;text-align:left;color:#2C2A29;font-size:16px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'user']"/><b>Nome:</b> {{$store.state.user.name}} {{$store.state.user.familyName}}
        </b-col>

        <b-col cols="12" style="height:50px;line-height:50px;margin-top:10px;text-align:left;color:#2C2A29;font-size:16px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'at']"/><b>Email:</b> {{$store.state.user.email}}
        </b-col>

        <b-col cols="12" style="height:50px;line-height:50px;margin-top:10px;text-align:left;color:#2C2A29;font-size:16px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'id-card']"/><b>CPF:</b> {{$store.state.user.cpf}}
        </b-col>

        <b-col cols="12" style="height:50px;line-height:50px;margin-top:10px;text-align:left;color:#2C2A29;font-size:16px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'mobile-android-alt']"/><b>Celular:</b> {{$store.state.user.phone}}
        </b-col>

        <b-col cols="5" style="height:50px;line-height:50px;margin-top:10px;text-align:left;color:#2C2A29;font-size:14px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'credit-card']"/><b>Cartões:</b>
        </b-col>

        <b-col cols="7" style="margin-top:10px;height:50px;line-height:50px;text-align:left;color:#FFFFFF;font-size:16px;">
          <div @click="gotToPath('/card')" style="max-width:250px;margin-top:8px;height:30px;line-height:30px;border-radius:4px;text-align:center;" :style="{color: '#FFFFFF', backgroundColor: getCssColor('primary_bt')}">Adicionar Cartão</div>
        </b-col>

        <b-col cols="12" v-if="$store.state.user.cards.length" style="text-align:left;color:#2C2A29;font-size:16px;">
          <b-row style="margin-top:20px;">
            <b-col cols="12" v-for="(card, idx) in $store.state.user.cards" v-bind:key="idx">
              <b-row style="padding:5px;">
                <b-col cols="4" style="border-bottom:1px solid #c0c0c0;">{{card.flag}}</b-col>
                <b-col cols="6" style="border-bottom:1px solid #c0c0c0;">{{card.number}}</b-col>
                <b-col cols="2">
                  <div @click="removeCard(card.id)" style="cursor:pointer;padding:5px;">
                    <div style="width:30px;height:30px;border-radius:15px;line-height:30px;text-align:center;box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);">
                    <font-awesome-icon style="font-size:18px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'trash']"/>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="5" style="height:50px;line-height:50px;margin-top:20px;text-align:left;color:#2C2A29;font-size:14px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'map-marked']"/><b>Endereços:</b>
        </b-col>

        <b-col cols="7" style="margin-top:30px;height:50px;line-height:50px;text-align:left;color:#FFFFFF;font-size:16px;">
          <div @click="gotToPath('/address')" style="max-width:250px;argin-top:8px;height:30px;line-height:30px;border-radius:4px;text-align:center;" :style="{color: '#FFFFFF', backgroundColor: getCssColor('primary_bt')}">Adicionar Endereço</div>
        </b-col>

        <b-col cols="12" v-if="$store.state.user.adresses.length" style="text-align:left;color:#2C2A29;font-size:16px;">
          <b-row style="margin-top:20px;">
            <b-col cols="12" v-for="(addr, idx) in $store.state.user.adresses" v-bind:key="idx">
              <b-row style="padding:5px">
                <b-col cols="10" style="border-bottom:1px solid #c0c0c0;">{{addr.shortName}}</b-col>
                <b-col cols="2">
                  <div @click="removeAddress(addr.id)" style="cursor:pointer;padding:5px;">
                    <div style="width:30px;height:30px;border-radius:15px;line-height:30px;text-align:center;box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);">
                      <font-awesome-icon style="font-size:18px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'trash']"/>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        
        <b-col cols="12" @click="logout()" style="margin:20px 0;cursor:pointer;height:50px;line-height:50px;text-align:left;color:#2C2A29;font-size:16px;">
          <font-awesome-icon style="font-size:20px;margin-right:15px;" :icon="['fal', 'sign-out']"/><b>Sair</b>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
import UserConn from '@/connection/user'
import colors from '@/mixins/colors'
import { EventBus } from '@/behaviours/event-bus'

export default {
  name: 'MyProfile',
  data () {
    return {
    }
  },
  mixins: [colors, navigation],

  created () {
  },

  methods: {

    backToProperHome () {
      if (this.$store.state.company.market_place === true){
        this.gotToPath('/company_list/' + this.$store.state.lastLatLongUri)
      } else {
        this.gotToPath('/home')
      }
    },

    async logout () {
      let did = await UserConn.logout(true)
      if (this.$store.state.company.market_place === true){
        location.reload()
      } else {
        if (did) {
          this.$router.push({path: '/home'})
        }
      }
    },

    async removeCard (id) {
      if (confirm('Deseja realmente remover o cartão?')) {
        this.$store.state.showLoading = true
        let result = await UserConn.removeCard(id)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
        if (id === this.$store.state.checkoutViewSelectedCard) {
          this.$store.state.checkoutViewSelectedCard = '0'
        }
        this.$store.state.showLoading = false
      }
    },

    async removeAddress (id) {
      if (confirm('Deseja realmente remover o endereço?')) {
        this.$store.state.showLoading = true
        let result = await UserConn.removeAddress(id)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
        if (id === this.$store.state.selectedAddressId) {
          location.reload()
        } else {
          this.$store.state.showLoading = false
        }
      }
    }

  }
}
</script>

<style lang="scss" scoped>

a {
    color: #2C2A29!important;
}

.container_profile {
  width: 100%;
  // max-width: 1330px;
  min-height: 100vh;
  background-color: #ffffff;
}
.header_profile{
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 20px;
}

</style>

